<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white pl-3">
                Dashboard
            </router-link>
            <router-link to="/school/student-information-system" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>Student Information System
            </router-link>
            <span><i class="fa fa-ellipsis-v px-2"></i>Student Promotion</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">

                    <div class="card bg-secondary border-0 mb-0">
                        <div class="card-body">
                            <div class="form-horizontal">
                                <form role="form" @submit.prevent="submitdata">
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-3">
                                            <div class="card bg-gradient-secondary">
                                                <h3 class="card-header">From which class</h3>
                                                <div class="card-body">
                                                    <div class="form-group">
                                                        <label>Class</label>
                                                        <select v-model="ClassIdval" class="form-control"
                                                            @change="getoption()">
                                                            <option value="0" v-if="!classitems">⏳ Loading...</option>
                                                            <option value="0" v-else>-- Select Class --</option>
                                                            <option v-for="item in classitems" :key="item.Id"
                                                                v-bind:value="item.Id">
                                                                {{ item.Sch_Class }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Option</label>
                                                        <select v-model="OptionIdval" class="form-control"
                                                            @change="getarm()">
                                                            <option value="0" v-if="!optionitems">⏳ Loading...</option>
                                                            <option value="0" v-else>-- Select Option --</option>
                                                            <option v-for="item in optionitems" :key="item.Id"
                                                                v-bind:value="item.Id">
                                                                {{ item.ClassOption }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Arm</label>
                                                        <select v-model="ArmIdval" class="form-control"
                                                            @change="getstudentbyarm()">
                                                            <option value="0" v-if="!armitems">⏳ Loading...</option>
                                                            <option value="0" v-else>-- Select Arm --</option>
                                                            <option v-for="item in armitems" :key="item.Id"
                                                                v-bind:value="item.Id">
                                                                {{ item.SectionName }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-3" v-if="ArmIdval">
                                            <div class="card bg-gradient-secondary">
                                                <h3 class="card-header">To which class</h3>
                                                <div class="card-body">
                                                    <div class="form-group">
                                                        <label>Class</label>
                                                        <select v-model="ToClassIdval" class="form-control"
                                                            @change="togetoption()">
                                                            <option value="0" v-if="!schclass">⏳ Loading...</option>
                                                            <option value="0" v-else>-- Select Class --</option>
                                                            <option v-for="item in schclass" :key="item.Id"
                                                                v-bind:value="item.Id">
                                                                {{ item.Sch_Class }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Option</label>
                                                        <select v-model="ToOptionIdval" class="form-control"
                                                            @change="togetarm()">
                                                            <option value="0" v-if="!tooptionitems">⏳ Loading...</option>
                                                            <option value="0" v-else>-- Select Option --</option>
                                                            <option v-for="item in tooptionitems" :key="item.Id"
                                                                v-bind:value="item.Id">
                                                                {{ item.ClassOption }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Arm</label>
                                                        <select v-model="ToArmIdval" class="form-control">
                                                            <option value="0" v-if="!toarmitems">⏳ Loading...</option>
                                                            <option value="0" v-else>-- Select Arm --</option>
                                                            <option v-for="item in toarmitems" :key="item.Id"
                                                                v-bind:value="item.Id">
                                                                {{ item.SectionName }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-6">

                                            <div v-if="ToArmIdval">
                                                <div class="justify-content-end form-inline my-3">
                                                    <base-input class="input-group-alternative"
                                                        placeholder="Search here..." addon-left-icon="fa fa-search"
                                                        v-model="searchval">
                                                    </base-input>
                                                </div>
                                                <div class="table-responsive promotion-table-wrapper">
                                                    <table class="table table-bordered table-dark promotion-table">
                                                        <thead>
                                                            <tr>
                                                                <th class="select-col">
                                                                    <input type="checkbox" v-model="selectAll"
                                                                        title="Select all students" />
                                                                </th>
                                                                <th></th>
                                                                <th>Student Name</th>
                                                                <th>Admission Number</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="item in filteredStudents" :key="item.Id"
                                                                v-bind:value="item.Id">
                                                                <td data-label="Select" class="select-col">
                                                                    <input type="checkbox" :value="item.Id"
                                                                        v-model="selectedStudents" />
                                                                </td>
                                                                <td data-label="Photo">
                                                                    <img v-if="item.Passport" :src="item.Passport"
                                                                        class="rounded" alt="" height="50" />
                                                                    <img v-else src="img/brand/loguser.png"
                                                                        class="rounded" alt="" height="50" />
                                                                </td>
                                                                <td data-label="Student Name">{{ item.StudentName }}
                                                                </td>
                                                                <td data-label="Admission Number">{{ item.AdmNo }}</td>
                                                            </tr>
                                                            <tr v-if="filteredStudents.length === 0">
                                                                <td colspan="4" class="text-center">No students found
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="d-flex justify-content-end mt-3">
                                                    <button type="button" class="btn btn-success"
                                                        :disabled="selectedStudents.length === 0"
                                                        v-on:click="promoteSelectedStudents">
                                                        Promote Selected ({{ selectedStudents.length }})
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner";
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin";
export default {
    name: "StudentPromotion",
    components: {
        PageSpinner,
    },
    mixins: [CheckStaffUser, Alert],
    data() {
        return {
            accessDetails: null,
            dataid: 0,
            ClassIdval: 0,
            OptionIdval: 0,
            ArmIdval: 0,
            StudIdval: 0,
            ToClassIdval: 0,
            ToOptionIdval: 0,
            ToArmIdval: 0,
            classitems: null,
            schclass: null,
            optionitems: null,
            armitems: null,
            tooptionitems: null,
            toarmitems: null,
            studentitems: null,
            selectedStudents: [],
            searchval: "",
            onloader: "none",
        };
    },

    computed: {
        filteredStudents() {
            if (!this.studentitems) return [];
            if (!this.searchval) return this.studentitems;
            let search = this.searchval.toLowerCase();
            return this.studentitems.filter(
                (item) =>
                    (item.StudentName && item.StudentName.toLowerCase().includes(search)) ||
                    (item.AdmNo && String(item.AdmNo).toLowerCase().includes(search))
            );
        },
        selectAll: {
            get() {
                return (
                    this.filteredStudents.length > 0 &&
                    this.filteredStudents.every((item) =>
                        this.selectedStudents.includes(item.Id)
                    )
                );
            },
            set(val) {
                this.selectedStudents = val
                    ? this.filteredStudents.map((item) => item.Id)
                    : [];
            },
        },
    },

    methods: {
        promoteStudent(StudIdval) {
            let StudIds = Array.isArray(StudIdval) ? StudIdval : [StudIdval];
            if (StudIds.length === 0) {
                this.ShowAlertWarning('Please select at least one student to promote', '');
                return;
            }
            let StudentIds = StudIds;
            let classId = this.ToClassIdval;
            let optionId = this.ToOptionIdval;
            let sectionId = this.ToArmIdval;
            let userdata = {
                classId,
                optionId,
                sectionId,
                StudentIds
            };
            this.onloader = "flex";
            this.$store
                .dispatch("PortalStudent/PromoteStudents", userdata)
                .then((resp) => {
                    console.log(resp);
                    if (resp.responseCode == "00") {
                        this.selectedStudents = [];
                        this.getstudentbyarm();
                        this.onloader = "none";
                        this.ShowAlertSuccess('Submitted Successfully', '');
                    } else {
                        this.onloader = "none";
                        this.ShowAlertError('Submission failed, try again', '');
                    }
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        promoteSelectedStudents() {
            this.promoteStudent(this.selectedStudents);
        },
        getclass() {
            this.classitems = null;
            this.studentitems = null;
            this.optionitems = null;
            this.armitems = null;
            this.onloader = "flex";
            this.$store
                .dispatch("getclass")
                .then((resp) => {
                    this.schclass = resp;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        getclassinclassassigned() {
            this.classitems = null;
            this.studentitems = null;
            this.optionitems = null;
            this.armitems = null;
            this.onloader = "flex";
            this.$store
                .dispatch("getclass")
                .then((resp) => {
                    this.classitems = resp;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        getoption() {
            this.studentitems = null;
            this.optionitems = null;
            this.armitems = null;
            this.OptionIdval = 0;
            this.onloader = "flex";
            let ClassId = this.ClassIdval;
            if (ClassId > 0) {
                this.$store
                    .dispatch("getoption", ClassId)
                    .then((resp) => {
                        this.optionitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        getarm() {
            this.studentitems = null;
            this.armitems = null;
            this.ArmIdval = 0;
            this.onloader = "flex";
            let OptionId = this.OptionIdval;
            if (OptionId > 0) {
                this.$store
                    .dispatch("getarm", OptionId)
                    .then((resp) => {
                        this.armitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        getstudentbyarm() {
            this.StudIdval = 0;
            this.selectedStudents = [];
            let Id = 1;
            let ClassId = this.ClassIdval;
            let OptionId = this.OptionIdval;
            let ArmId = this.ArmIdval;
            let SubjectId = 1;
            let StudId = 1;
            let SessionId = 1;
            let TermId = 1;
            let processop = this.process;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            if (ArmId > 0) {
                let userdata = {
                    Id,
                    ClassId,
                    OptionId,
                    ArmId,
                    SubjectId,
                    StudId,
                    SessionId,
                    TermId,
                    processop,
                    username,
                    accesskey,
                };
                this.onloader = "flex";
                this.$store
                    .dispatch("getstudentbyarm", userdata)
                    .then((resp) => {
                        this.studentitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        togetoption() {
            this.tooptionitems = null;
            this.toarmitems = null;
            this.ToOptionIdval = 0;
            this.onloader = "flex";
            let ToClassId = this.ToClassIdval;
            if (ToClassId > 0) {
                this.$store
                    .dispatch("getoption", ToClassId)
                    .then((resp) => {
                        this.tooptionitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        togetarm() {
            this.toarmitems = null;
            this.ToArmIdval = 0;
            this.onloader = "flex";
            let ToOptionId = this.ToOptionIdval;
            if (ToOptionId > 0) {
                this.$store
                    .dispatch("getarm", ToOptionId)
                    .then((resp) => {
                        this.toarmitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        frontEndDateFormat(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        backEndDateFormat(date) {
            return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
        },
    },
    mounted() {
        this.getclassinclassassigned();
        this.getclass();
    },
};
</script>

<style scoped>
.select-col {
    width: 45px;
    text-align: center;
}

.select-col input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.promotion-table th,
.promotion-table td {
    vertical-align: middle;
}

/* Stack table rows into cards on small screens */
@media (max-width: 767.98px) {
    .promotion-table thead {
        display: none;
    }

    .promotion-table,
    .promotion-table tbody,
    .promotion-table tr,
    .promotion-table td {
        display: block;
        width: 100%;
    }

    .promotion-table tr {
        margin-bottom: 1rem;
        border: 1px solid #1e3e6e;
        border-radius: 0.375rem;
        overflow: hidden;
    }

    .promotion-table td {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        border: none;
        text-align: right;
    }

    .promotion-table td::before {
        content: attr(data-label);
        font-weight: 700;
        text-align: left;
    }

    .promotion-table td.select-col::before {
        margin-right: auto;
    }
}
</style>
